module.exports = __webpack_public_path__ + "static/media/form-and-decay-sm-1.fce21bfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/form-and-decay/form-and-decay-sm-1.jpg
// module id = 4132
// module chunks = 14